// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eYSOm","delete":"styles_delete__Ww9eA","update":"styles_update__1Pwjg","add":"styles_add__2YETZ"};